import {
  Bot,
  ClipboardList,
  CreditCard,
  Home,
  Map,
  MessageSquare,
  Network,
  Newspaper,
  Plus,
  Send,
  Settings,
  Ticket,
  TrendingUp,
  Users,
  Wallet,
  Wrench,
} from 'lucide-react';

export const commandSidebarItems = [
  { section: 'Core', to: '/command-center', label: 'Command Center', icon: TrendingUp },
  { section: 'Core', to: '/triage', label: 'Triage Queue', icon: ClipboardList },
  { section: 'Core', to: '/topology?mode=live', label: 'Topology Workspace', icon: Map },
  { section: 'Core', to: '/operations', label: 'Operations Overview', icon: ClipboardList },
  { section: 'Core', to: '/execution-logs', label: 'Execution Log', icon: ClipboardList },
  { section: 'Core', to: '/recovery', label: 'Recovery & Actions', icon: Wrench },
  { section: 'Core', to: '/tickets', label: 'Tickets', icon: Ticket },
  { section: 'Core', to: '/customers', label: 'Customers', icon: Users },
  { section: 'Core', to: '/infrastructure', label: 'Infrastructure', icon: Network },
  { section: 'Core', to: '/ai-console', label: 'AI Console', icon: Bot },

  { section: 'Pelanggan', to: '/dadu/pengajuan-pelanggan', label: 'Pengajuan Pelanggan', icon: ClipboardList },

  { section: 'Topology', to: '/dadu/monitoring', label: 'Live Monitor', icon: Map },
  { section: 'Topology', to: '/dadu/ftth', label: 'Plan / Design', icon: Network },
  { section: 'Topology', to: '/dadu/ftth?context=planning&planningAction=olt', label: 'Tambah OLT', icon: Plus },
  { section: 'Topology', to: '/dadu/ftth?context=planning&planningAction=odp', label: 'Tambah ODP', icon: Plus },

  { section: 'Billing', to: '/dadu/billing', label: 'Billing & Invoice', icon: CreditCard },
  { section: 'Billing', to: '/dadu/keuangan', label: 'Keuangan', icon: Wallet },

  { section: 'Operasional', to: '/dadu/penanganan', label: 'Penanganan Ticket', icon: Wrench },
  { section: 'Operasional', to: '/dadu/recovery-rollout', label: 'Recovery Rollout', icon: Bot },
  { section: 'Operasional', to: '/performa-teknisi', label: 'Performa Teknisi', icon: Users },
  { section: 'Operasional', to: '/dadu/whatsapp-live', label: 'Live Chat WA', icon: Send },
  { section: 'Operasional', to: '/dadu/whatsapp-templates', label: 'Template WA', icon: MessageSquare },

  { section: 'Infrastruktur', to: '/dadu/infrastruktur?tab=sites', label: 'Master Site', icon: Map },
  { section: 'Infrastruktur', to: '/dadu/infrastruktur?tab=nas', label: 'NAS / Router', icon: Network },
  { section: 'Infrastruktur', to: '/dadu/router-monitoring', label: 'Router Monitoring', icon: Network },
  { section: 'Infrastruktur', to: '/dadu/infrastruktur?tab=capacity', label: 'Capacity Overview', icon: TrendingUp },
  { section: 'Infrastruktur', to: '/dadu/manajemen/ppp-profile', label: 'Paket Internet', icon: Wrench },
  { section: 'Infrastruktur', to: '/dadu/manajemen/hotspot-profile', label: 'Profil Hotspot', icon: Wrench },
  { section: 'Infrastruktur', to: '/dadu/hotspot/overview', label: 'Hotspot Overview', icon: Home },
  { section: 'Infrastruktur', to: '/dadu/hotspot/voucher', label: 'Voucher', icon: Ticket },
  { section: 'Infrastruktur', to: '/dadu/hotspot/reseller', label: 'Reseller', icon: Users },
  { section: 'Infrastruktur', to: '/dadu/hotspot/analytics', label: 'Analytics', icon: TrendingUp },

  { section: 'Sistem', to: '/dadu/berita', label: 'Berita', icon: Newspaper },
  { section: 'Sistem', to: '/dadu/kontak', label: 'Pesan Masuk', icon: MessageSquare },
  { section: 'Sistem', to: '/dadu/users', label: 'Manajemen User', icon: Users },
  { section: 'Sistem', to: '/dadu/open-platform', label: 'Open Platform API', icon: Bot },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=freeradius', label: 'FreeRADIUS', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=genieacs', label: 'GenieACS', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=opennms', label: 'OpenNMS', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=whatsapp', label: 'WhatsApp', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=reminder', label: 'Auto Reminder', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=security', label: 'Keamanan Sesi', icon: Settings },
  { section: 'Sistem', to: '/dadu/pengaturan?tab=payment', label: 'Payment Gateway', icon: Settings },
];
